var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.getFields()),function(component,i){return _c('component-compiler',{key:`form-${i}`,attrs:{"content":component}})}),_c('br')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }